import { EndpointEventMappings } from './EndpointEventMappings';
import { Office365EventMappings } from './Office365EventMappings';
import { EventMappings } from './EventMappings';

export class EventMappingsFactory {
  /*
   If you want to add a new sensor, create a new event mappings class and
   add it here
   */
  private static readonly allEventMappingsConstructors: Array<typeof EventMappings> = [
    EndpointEventMappings,
    Office365EventMappings,
  ];

  public static getAllEventMappingsBySensorName(dependencies: { translateFn: Function }): {
    [sensorName: string]: EventMappings;
  } {
    const allEventMappingsBySensorName = {};

    this.allEventMappingsConstructors.forEach(eventMappingConstructor => {
      const eventMappings = new eventMappingConstructor(dependencies);
      allEventMappingsBySensorName[eventMappings.sensorName] = eventMappings;
    });

    return allEventMappingsBySensorName;
  }
}
